import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { useParams } from "react-router-dom";
import "./Profile.css";
import { useStateValue } from "../StateProvider";
import Post from "./Post";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import GestureOutlinedIcon from "@mui/icons-material/GestureOutlined";

function Profile() {
  const { userid } = useParams();
  const [posts, setPosts] = useState([]);
  const [person, setPerson] = useState([]);
  const [{ user }] = useStateValue();

  useEffect(() => {
    document.title = `${person.name} | tarok.tech`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [person.name]);

  useEffect(() => {
      if (userid && user) {
        setPerson(user);
      } else {
        db.collection("Users")
          .doc(userid)
          .get()
          .then((s) => {
            setPerson(s.data());
          });
      }
      db.collection("Posts")
        .where("userId", "==", userid)
        .orderBy("timestamp", "desc")
        .limit(6)
        .get()
        .then((snapshot) => {
          setPosts(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              post: doc.data(),
            }))
          );
        });
  }, [user, userid]);

  return (
    <div>
      <div className="profileContainer">
        <img className="profileAvatar" src={person.image} alt="" />
        <h2 className="profileName">{person.name}</h2>

        <div className=" profileContainerInfo">
          <GestureOutlinedIcon />
          <h6 className="profileName">{person.bio}</h6>
        </div>
        <div className=" profileContainerInfo">
          <PlaceOutlinedIcon />
          <h6 className="profileName">{person.location}</h6>
        </div>
        <div className=" profileContainerInfo">
          <SchoolOutlinedIcon />
          <h6 className="profileName">
            {person.dept}, {person.institute}
          </h6>
        </div>
      </div>

      <div className="posts">
        {posts.map(({ id, post }) => (
          <Post key={id} postId={id} user={user} post={post} />
        ))}
      </div>
    </div>
  );
}

export default Profile;
